import gql from 'graphql-tag'

const addSelfServiceCase = gql`
  mutation addSelfServiceCase($data: SelfServiceCaseInput!) {
    addSelfServiceCase(data: $data)
  }
`

export { addSelfServiceCase }
